import { useLocation } from "react-router-dom";
import { useRouteOverlay } from "@/shared/hooks/useRouteOverlay";
import type { DialogDismissReason } from "@/shared/components/ui/FullScreenDialog";

export function useFormPreviewOverlay() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const formId = params.get("formPreview") ?? undefined;
  const appointmentId = params.get("formAppointment") ?? undefined;
  const expectedVersionId = params.get("formVersionId") ?? undefined;
  const fallback = new URLSearchParams(params);
  fallback.delete("formPreview");
  fallback.delete("formAppointment");
  fallback.delete("formVersionId");
  const fallbackPath = `${location.pathname}${fallback.size ? `?${fallback}` : ""}${location.hash}`;
  const { openOverlay, closeOverlay } = useRouteOverlay(fallbackPath);
  const openPreview = (id: string, bookingId?: string, versionId?: string, opener?: HTMLElement) => {
    const next = new URLSearchParams(location.search);
    next.set("formPreview", id);
    if (bookingId) next.set("formAppointment", bookingId);
    else next.delete("formAppointment");
    if (versionId) next.set("formVersionId", versionId);
    else next.delete("formVersionId");
    openOverlay(`${location.pathname}?${next}${location.hash}`, opener);
  };
  const closePreview = (reason?: DialogDismissReason) => {
    if (reason !== "navigate") closeOverlay();
  };
  return { formId, appointmentId, expectedVersionId, openPreview, closePreview };
}
